import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  MARK_AS_READ,
  MARK_AS_READ_SUCCESS,
  MARK_AS_READ_FAILURE,
  MARK_AS_READ_SINGLE,
  MARK_AS_READ_SINGLE_SUCCESS,
  MARK_AS_READ_SINGLE_FAILURE,
  MARK_AS_SEEN,
  MARK_AS_SEEN_SUCCESS,
  MARK_AS_SEEN_FAILURE,
  CREATE_SUPPORT,
  CREATE_SUPPORT_SUCCESS,
  CREATE_SUPPORT_FAILURE,
} from "../constants";

export default class NotificationAction {
  static getNotifications(cb) {
    return {
      type: GET_NOTIFICATIONS,
      cb,
    };
  }
  static getNotificationsSuccess(payload) {
    return {
      type: GET_NOTIFICATIONS_SUCCESS,
      payload,
    };
  }
  static getNotificationsFailure() {
    return {
      type: GET_NOTIFICATIONS_FAILURE,
    };
  }
  static markAsRead(cb) {
    return {
      type: MARK_AS_READ,
      cb,
    };
  }
  static markAsReadSuccess(payload) {
    return {
      type: MARK_AS_READ_SUCCESS,
      payload,
    };
  }
  static markAsReadFailure() {
    return {
      type: MARK_AS_READ_FAILURE,
    };
  }
  static markAsReadSingle(payload, cb) {
    return {
      type: MARK_AS_READ_SINGLE,
      payload,
      cb,
    };
  }
  static markAsReadSingleSuccess(payload) {
    return {
      type: MARK_AS_READ_SINGLE_SUCCESS,
      payload,
    };
  }
  static markAsReadSingleFailure() {
    return {
      type: MARK_AS_READ_SINGLE_FAILURE,
    };
  }
  static markAsSeen(cb) {
    return {
      type: MARK_AS_SEEN,
      cb,
    };
  }
  static markAsSeenSuccess(payload) {
    return {
      type: MARK_AS_SEEN_SUCCESS,
      payload,
    };
  }
  static markAsSeenFailure() {
    return {
      type: MARK_AS_SEEN_FAILURE,
    };
  }
  static createSupport(payload, cb) {
    return {
      type: CREATE_SUPPORT,
      payload,
      cb,
    };
  }
  static createSupportSuccess(payload) {
    return {
      type: CREATE_SUPPORT_SUCCESS,
      payload,
    };
  }
  static createSupportFailure() {
    return {
      type: CREATE_SUPPORT_FAILURE,
    };
  }
}
